// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__7oLTZ","logo_custom":"Logo_logo_custom__Xe3fu"};